/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    Dialog, DialogContent, Grid, CircularProgress,
    Button,
} from '@material-ui/core';
import { object, bool, string, func } from 'prop-types';
import closeIcon from '../Assets/filterCloseIcon.svg';
import { useDialogStyles } from '../../../../../style/commonStyles';

// import StyledButton from '../../../../../../../components/EnterpriseDesignSystem/Button/StyledButton';

const DeleteDialog = ({
    classes, loading, error, setError, isShowingDeleteDialog, setIsShowingDeleteDialog, handleClick, description
}) => {
    const DeleteDialogStyles = useDialogStyles();
    return (
        <Dialog open={isShowingDeleteDialog} fullWidth onClose={() => setIsShowingDeleteDialog(false)}>
            <DialogContent className={DeleteDialogStyles.dialogContent}>
                <Grid container direction="column" alignItems="center" spacing={2} style={{ position: 'relative' }}>
                    <div
                        role="button"
                        tabIndex={0}
                        onClick={() => { setIsShowingDeleteDialog(false); setError('') }}
                        onKeyDown={() => { }}
                        className={DeleteDialogStyles.closeButton}
                    >
                        <span><img src={closeIcon} alt="close icon" /></span>
                    </div>
                    <Grid item>
                        <p className={DeleteDialogStyles.dialogText}>Are you sure you want to delete this {description.toLowerCase()}?</p>
                </Grid>
                <Grid container item xs={12} spacing={2} className={DeleteDialogStyles.commonGap}>
                    {error
                        && (
                            <Grid container justifyContent="center" alignItems="center">
                                <p className={DeleteDialogStyles.errorContainer}>
                                    {error}
                                </p>
                            </Grid>
                        )}
                    <Grid item xs={12}>
                        {
                            /*
                                * The EDS Button implementations are <StyledButtons> below. We can remove <Button> once we feel comfortable with EDS buttons.
                                */
                        }
                        <Button
                            disabled={loading}
                            variant="contained"
                            color="primary"
                            fullWidth
                            className={classes.commonBtnContained}
                            style={{ height: '56px' }}
                            onClick={() => handleClick()}>
                            {loading ? <CircularProgress /> : `Yes, Delete This ${description.toLowerCase()}`}
                        </Button>
                        {/* <StyledButton
                            fullWidth
                            label={loading ? <CircularProgress size={20}/> : `Yes, Delete This ${description}`}
                            variant="primary"
                            size="md"
                            handleOnClick={handleClick}
                            disabled={loading}
                        /> */}
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="outlined"
                            color="primary"
                            fullWidth
                            className={classes.outlinedPrimaryBtn}
                            style={{ height: '56px' }}
                            onClick={() => { setIsShowingDeleteDialog(false); setError('') }}
                        >
                            Cancel
                        </Button>
                        {/* <StyledButton
                            fullWidth
                            label="Cancel"
                            variant="secondary"
                            size="md"
                            handleOnClick={() => {
                                setIsShowingDeleteDialog(false);
                                setError('');
                            }}
                        /> */}
                    </Grid>
                </Grid>
            </Grid>
        </DialogContent>
    </Dialog>
)};

DeleteDialog.propTypes = {
    setError: func,
    loading: bool.isRequired,
    classes: object.isRequired,
    error: string.isRequired,
    handleClick: func.isRequired,
    description: string.isRequired,
    isShowingDeleteDialog: bool.isRequired,
    setIsShowingDeleteDialog: func.isRequired,
};

DeleteDialog.defaultProps = {
    setError: () => {}
};

export default DeleteDialog;
